module.exports = __webpack_public_path__ + "static/media/gas-station-crop.f233b60b.png";